import React from 'react';
import { getDevicePlatform } from './utility';

const isMobile =
    typeof window !== 'undefined' ? getDevicePlatform.any() : false;

interface SharedEpigraphViewerProps {
    epigraphReady: boolean;
    error?: boolean;
    sku?: string;
    uaCode?: string;
    gaMeasurementId?: string;
    foregroundImageUrl?: string;
    mobileContainerClassName?: string;
    pictureClassName?: string;
}

const SharedEpigraphViewer: React.FC<SharedEpigraphViewerProps> = ({
    epigraphReady,
    error,
    sku,
    uaCode,
    gaMeasurementId,
    foregroundImageUrl,
    mobileContainerClassName,
    pictureClassName,
}) => {
    if (error) {
        return (
            <div className={mobileContainerClassName}>
                <div style={{ padding: '2rem', textAlign: 'center' }}>
                    Unable to load 3D viewer
                </div>
            </div>
        );
    }

    if (!epigraphReady) {
        return (
            <div className={mobileContainerClassName}>
                <div style={{ padding: '2rem', textAlign: 'center' }}>
                    Loading 3D model...
                </div>
            </div>
        );
    }

    if (typeof window !== 'undefined' && isMobile) {
        return (
            <div className={mobileContainerClassName}>
                <epigraph-ar
                    viewer-visible
                    product-tour-visible
                    button-mode="none"
                    sku={sku}
                    ua-code={uaCode}
                    camera-orbit="-45deg 90deg 6m"
                    ga4-code={gaMeasurementId}
                    ga-measurement-id={gaMeasurementId}
                >
                    <button
                        slot="mobile-product-tour-button"
                        style={{ zIndex: 1 }}
                    >
                        <picture className={pictureClassName}>
                            <img
                                src={foregroundImageUrl}
                                alt="mobile-product-tour-image"
                            />
                        </picture>
                    </button>
                </epigraph-ar>
            </div>
        );
    }

    return (
        <epigraph-ar
            viewer-visible
            product-tour-visible
            button-mode="none"
            sku={sku}
            ua-code={uaCode}
            camera-orbit="-45deg 90deg 6m"
            ga-measurement-id={gaMeasurementId}
            auto-start
        />
    );
};

export default SharedEpigraphViewer;
